<script>
import mixin from '@/plans/mx/shopping-cart';

export default {
  mixins: [mixin],
  methods: {
    $renderPrice() {
      return this.mx_plans.map((plan) => {
        return (
          <div class="opc-cart-item">
            {this.mx_title(this.$t('billing.zone_ppm.title'), plan.cartInfo.selected_number * plan.amount)}
            <h2 class="opc-cart-item__text">{ this.$t('billing.zone_ppm.one_time') }</h2>
          </div>
        );
      });
    },
  },
};
</script>
